module.exports = new __parcel__URL__("management-platform-screenshot.a77c235c.png").toString();